/* eslint-disable react/display-name */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TimesheetLabel } from 'modules/timesheet-labels/labelSchema';

import {
  DetailsControlProps,
  SearchFacetType,
  SuggestionItemProp
} from '../type';
import LabelFacetDetails from '../LabelFacetDetails';
import LabelOptionItem from '../OptionItem';
import { projectTag } from './tag';
import makeCriteriaProvider from './makeCriteriaProvider';
import { useProjectLabelSearch } from './hooks/useProjectLabelSearch';
import ProjectIcon from './ProjectIcon';

const icon = <ProjectIcon />;
const noProjectsMessage = <FormattedMessage id="search.facets.noProject" />;

export const getDetailsControl = (
  label: TimesheetLabel,
  onDropdownValueChange?: (mappedValue: any, label: any) => void,
  isDisable?: (label: any) => boolean,
  settingInitialDopDownValue?: (label: any, setSelected: any) => void
): React.FC<DetailsControlProps> => ({
  selected,
  setSelected
}: DetailsControlProps) => {
  const { options, loading, searchHandler, hasMore } = useProjectLabelSearch();
  return (
    <LabelFacetDetails
      selected={selected}
      setSelected={setSelected}
      options={options}
      loading={loading}
      searchHandler={searchHandler}
      label={label}
      icon={icon}
      noOptionsText={noProjectsMessage}
      hasMore={hasMore}
      isDisable={isDisable}
      onDropdownValueChange={onDropdownValueChange}
      settingInitialDopDownValue={settingInitialDopDownValue}
    />
  );
};

const SuggestionItem: React.FC<SuggestionItemProp> = ({
  option
}: SuggestionItemProp) => (
  <LabelOptionItem testId={option.id} value={option.label} icon={icon} />
);

export const getProjectFacet = (
  label: TimesheetLabel,
  onDropdownValueChange?: (mappedValue: any, label: any) => void,
  isDisable?: (label: any) => boolean,
  settingInitialDopDownValue?: (label: any, setSelected: any) => void
): SearchFacetType => ({
  makeCriteriaProvider: makeCriteriaProvider(label),
  tag: projectTag,
  DetailsControl: getDetailsControl(
    label,
    onDropdownValueChange,
    isDisable,
    settingInitialDopDownValue
  ),
  SuggestionItem: SuggestionItem
});

export default getProjectFacet;
